import React from "react";
import Map from "../images/map.png";
import VectorDesktop from "../images/Vector_desktop.png";
import styled from "styled-components";
import { fonts, colors, mediaQueries } from "../shared/config";

const Wrapper = styled.div`
    background: ${colors.black1};
    display: flex;
    flex-direction: column; 
    min-height: 100vh;
`;


const Container1 = styled.div`
    background: ${colors.black1};
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 40px;
    padding-top: 5%;
    padding-bottom: 4%;

    ${mediaQueries.notMobile} {
        align-items: center;
    }

    ${mediaQueries.mobile} {
      flex-direction: column;
      align-items: center;
      height: auto;
      /* margin: 4em auto; */
    }
  `;

const Container2 = styled.div`
    background: ${colors.black1};
    justify-content: center;
    align-items: center;
`;

const Img = styled.img`
    width: 50vw;
    ${mediaQueries.mobile} {
        width: 80vw;
        margin-top: 20px;
    }
`;

const Textcontainer2 = styled.div`
    display: inline-block;
    text-align: left;
    padding: 3%;
`
const Textcontainer3 = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 5%;
    padding-right: 5%;
    padding-bottom: 5%;

    ${mediaQueries.mobile} {
        width: auto;
        margin: 0 10px;
    }
`

const BodyText = styled.text`
    font-family: Cardo;
    font-size: 18px;
    font-style: normal;
    font-weight: normal;
    color: white;
    text-align: left;
    padding-bottom:1rem;
`;

const Header = styled.text`
    font-family: Staatliches;
    font-style: normal;
    font-weight: normal;
    font-size: 96px;
    line-height: 75%;
    padding-bottom: 20px;
    color: ${colors.red1};

    ${mediaQueries.mobile} {
        font-size: 36px;
    }
`;

const Subheading = styled.div`
    font-family: Staatliches;
    font-style: normal;
    font-weight: normal;
    font-size: 48px;
    line-height: 75%;
    color: white;

    ${mediaQueries.mobile} {
        font-size: 24px;
    }
`;

const Credits = styled.div`
  font-family: ${fonts.credits};
  font-weight: 400;
  padding-left: 10px;
  font-size: 12px;
  text-align: right;
  padding-right: 10px;
  color: white;
`;

export default function Offtolaces(props) {
    return (
        <>
        <Wrapper>
            <Container1>
                    <Textcontainer2>
                    {props.data.map(block=>{
                        if(block.type==="header") {
                            return(<Header>{block.content}</Header>)
                        }
                        if(block.type==="subheader") {
                            return(<Subheading>{block.content}</Subheading>)
                        }                        
                    })}
                    </Textcontainer2>  

                    
                    {props.data.map(block=>{
                        if(block.type==="image") {
                            return(
                                <div>
                                    <Img src={block.image_link}/>
                                    <Credits> {block.image_credits}</Credits>
                                </div>  
                                )
                        }                     
                    })}
                    
            </Container1>

            <Container2>
                <Textcontainer3>
                    {props.data.map(block=>{
                        if(block.type=="paragraph") {
                            return(
                                <BodyText>{block.content}</BodyText>
                            
                            )
                        }                     
                    })}
                </Textcontainer3> 
            </Container2>
        </Wrapper>
        </>
    )
}